export default __webpack_public_path__ + "static/media/marsh.83c1814c.jpg";